// extracted by mini-css-extract-plugin
export default {"contentWrapper":"styles_contentWrapper__W1AJL","heroImgContainer":"styles_heroImgContainer__+AmdP","heroPara":"styles_heroPara__NOjkp","heroHeading":"styles_heroHeading__r0RwX"};